import { toast } from "react-toastify";
import { EffectiveMarginTarget } from "models/project-margin-target";

// API only; callers dispatch setEffectiveMarginTarget (see hooks/useProjectMarginTarget).
export const getEffectiveMarginTarget = async (fiscalYear?: number): Promise<EffectiveMarginTarget | null> => {
    try {
        const qs = fiscalYear ? `?fiscalYear=${fiscalYear}` : "";
        const res = await fetch(`${process.env.REACT_APP_API_URL}/project-margin-targets/current${qs}`, {
            credentials: 'include',
            method: 'GET',
        });

        if (!res.ok) {
            const errBody = await res.json().catch(() => null);
            throw new Error(errBody?.message ?? "Error getting the project margin target");
        }

        return (await res.json()).data as EffectiveMarginTarget;
    } catch (err: any) {
        toast.error(err.message ?? "Error getting the project margin target");
        return null;
    }
}
